import React, { useEffect, useState } from 'react';
import { FaUser, FaPhone, FaEnvelope, FaBriefcase, FaIdBadge } from 'react-icons/fa';
import { useWorkshop } from "../Common/WorkshopContext";

const EmployeeModal = ({ show, handleClose, employee, handleSave }) => {
    const { workshopId } = useWorkshop();
    const [formData, setFormData] = useState({
        id: '',
        name: '',
        phone: '',
        email: '',
        position: 'Mechanic',
        workshopId: workshopId
    });

    useEffect(() => {
        if (employee) {
            setFormData({
                id: employee.id || '',
                name: employee.name || '',
                phone: employee.phone || '',
                email: employee.email || '',
                position: employee.position || 'Mechanic',
                workshopId: workshopId
            });
        }
    }, [employee]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = () => {
        handleSave(formData);
        handleClose();
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white w-full max-w-xl mx-auto rounded-2xl shadow-lg p-6 md:p-8">
                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-lg font-semibold text-gray-800">
                        {employee ? 'Edit Employee' : 'Add Employee'}
                    </h2>
                    <button onClick={handleClose} className="text-gray-400 hover:text-gray-700 text-xl">
                        &times;
                    </button>
                </div>

                {/* Form */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {employee && (
                        <div className="md:col-span-2">
                            <label className="text-sm text-gray-600 mb-1 block">Employee ID</label>
                            <input
                                name="id"
                                value={formData.id}
                                readOnly
                                className="w-full px-4 py-2 rounded-md border bg-gray-100 text-sm"
                            />
                        </div>
                    )}

                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Name</label>
                        <input
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter full name"
                            className="w-full px-4 py-2 rounded-md border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Phone</label>
                        <input
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="+91..."
                            className="w-full px-4 py-2 rounded-md border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Email</label>
                        <input
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="user@example.com"
                            className="w-full px-4 py-2 rounded-md border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Position</label>
                        <select
                            name="position"
                            value={formData.position}
                            onChange={handleChange}
                            className="w-full px-4 py-2 rounded-md border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            <option>Mechanic</option>
                            <option>Supervisor</option>
                            <option>Controller</option>
                            <option>Electrician</option>
                            <option>Welder</option>
                            <option>Marketing</option>
                        </select>
                    </div>
                </div>

                {/* Buttons */}
                <div className="mt-6 flex justify-end gap-3">
                    <button
                        onClick={handleClose}
                        className="px-5 py-2 text-sm bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="px-6 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                    >
                        {employee ? 'Update' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EmployeeModal;
